import styled from 'styled-components'

export const Item = styled.div`
  padding: 16px 12px 12px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.primary.main};
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  transition: 0.3s;
  gap: 10px;

  ${({ selected, theme }) =>
    selected
      ? `
    background: ${theme.primary.main};
    color: ${theme.primary.contrastText};
  `
      : ''}

  &:hover {
    opacity: 0.75;
  }

  & .last-message {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }

  @media (max-width: 1200px) {
    padding: 14px 10px 10px 10px;
    gap: 8px;

    & .last-message {
      max-width: 100px;
    }
  }
`

export const PatientSection = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const LastMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
`

export const LastMessage = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

// Scanning the list, the automatic reply is indistinguishable from something a
// colleague wrote. This marks it without pushing the preview text off the card.
export const AutomatedTag = styled.span`
  ${({ theme }) => `
    background: ${theme.silver.main};
    color: ${theme.black.main};
  `}
  flex-shrink: 0;
  margin-right: 4px;
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const Badge = styled.div`
  ${({ theme }) => `
    background: ${theme.primary.main};
    color: ${theme.primary.contrastText};
  `}
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`
